/* eslint-disable no-magic-numbers */

import lodash from 'lodash';

import {EASINGS} from '../../ecs/easingHelper';

/**
 * The name that signals this preset.
 * @const {string}
 */
export const PRESET_ZINDEX_RISE_INTO_PLACE = 'zIndexRiseIntoPlace';

/**
 * The zIndex details.
 *
 * @type {{
 *   name: string,
 *   humanName: string,
 *   flow: string,
 *   details: Object.<string, {
 *     easing: string,
 *     parse: boolean,
 *     values: *|Array.<*>,
 *     time: {start: (string|number), end: (string|number)}
 *   }>,
 *   template: {}
 * }}
 */
export const rotatePresetDetails = {
  // The name of the preset.
  name: PRESET_ZINDEX_RISE_INTO_PLACE,

  // A human friendly name for the preset.
  humanName: 'Z-Index - Rise Into Place',

  // The element names that this preset can be used for or true for all elements.
  elements: true,

  // The preset direction: in, out, middle. This is used in the UI logic.
  flow: 'in',

  // Each property that will change during the transition.
  details: {
    'zIndex.position': {
      // The name of the easing this property will use.
      easing: EASINGS.linear,

      // The start and end times for the transition of this property.
      time: {
        start: 'start.0',
        end: 'start.1000',
      },

      // The value of the property that will change during the transition.
      values: [-3, 0],
    },
  },

  // How this preset can be used in the source (including optional parameters).
  // This will be turned into a JSON string, so no functions can be used.
  template: {
    preset: PRESET_ZINDEX_RISE_INTO_PLACE,
    options: {},
  },
};

rotatePresetDetails.template.options = lodash.cloneDeep(rotatePresetDetails.details);

// This defines the key in the presets object.
export const presetName = PRESET_ZINDEX_RISE_INTO_PLACE;

// This defines the value of the presets object.
export default rotatePresetDetails;
